import Const from '../components/Const';
import { isDesktop } from './AppUtils';

let PROCESS_VIDEOS = true;
let SHOW_THUMBNAILS = true;
const UNSET = -1;
const MAX_LOADED_VIDEOS = 3;
//
let lazyLoadingObserver = null;
let videoDivs = [];
let lastObservedVideoIndex = UNSET;
let lastObservedVideoIndexMap = new Map([
        [Const.HOME, UNSET],
        [Const.LOGIN_USER, UNSET],
        [Const.ANY_USER, UNSET],
        [Const.SEARCH, UNSET],
]);

export function setLazyLoadingProcessing(cond) {
  // afects only desktops
  PROCESS_VIDEOS = cond;
}

export function showThumbnailsInGallery(cond) {
  //affects only desktops
  SHOW_THUMBNAILS = cond;
}

export function createLazyLoadingObserver() {
  // is invoked from SessionUtils
  let observer;
  let options = {
    root: null,
    rootMargin: '-60% 0px -30% 0px', // we reduce the observer viewport by 60% from the top and 30% from the bottom
                                     // this gives us a chance to see up to 3 videos on screen (portrait)
                                     // and it works cimmetrical for sroll up and down
    threshold: 0 // trigger observer a s soon as one pixel of the target (video div) eners the above mentione interval
  };

  observer = new IntersectionObserver((entries) => {
    entries.forEach(({target, isIntersecting }) => {
      if (isIntersecting) {
        manageVideos(target);
      } 
    });
  }, options);
  lazyLoadingObserver = observer;
}

export async function processVideoDivs(that)  {
  let nodeList;
  let ret = false;

  if (PROCESS_VIDEOS || !isDesktop()) {
    nodeList = document.querySelectorAll('[videourl]'); 
    if (nodeList.length) {
      videoDivs = Array.from(nodeList); // observer will observe video divs, not videos themselves
      await addLazyVideoLoadListener(that);
      ret = true;
    }
  }
  return ret;
}

export async function addLazyVideoLoadListener(that) {
  try {
    lazyLoadingObserver.disconnect();
    unObserveAllVideoDivs();
    await videosAreReady(); 
    if (lastObservedVideoIndex === UNSET)  {
      lastObservedVideoIndex = lastObservedVideoIndexMap.get(that.className); // to be able to re-save it 
                                                                              // if nothig will be observed in this round
    }
    videoDivs.forEach((videoDiv) => {
      if (videoDiv) {
        lazyLoadingObserver.observe(videoDiv);
      }
    });
  } 
  catch (error) {
    console.error(error.message);
  }
}

export function videosAreReady(timeout = 1000) { 
  return new Promise((resolve, reject) => {
    let startTime = Date.now();

    const checkVideos = () => {
      let video;
      let ret = true;

      if (videoDivs.length) {
        for (let videoDiv of videoDivs) {
          video = getVideoFromDiv(videoDiv);
          if (!video) {
            ret = false;
            break;
          }
        }
      }
      if (ret) {
        resolve(true);
      } else if (Date.now() - startTime >= timeout) { 
        reject(new Error("Timeout reached, videos not ready."));
      } else {
        setTimeout(checkVideos, 50); // Retry after 50ms
      }
    };
    checkVideos();
  });
}

export function getLazyLoadingObserver() {
  return lazyLoadingObserver;
}

export function manageVideos(target) {
  let ind = videoDivs.findIndex(videoDiv => (videoDiv.id === target.id));

  preloadNeighbourVideosOnly(ind);
}

export function preloadNeighbourVideosOnly(ind) {
  let numOfvideos = videoDivs.length;
  let videoEl;
  let src;
  let isInterceptedEl = false;
  let delta = (ind === 0) ? 2 : 1;
  
  setLastObservedVideoIndex(ind);
  console.log('---', ind)
  for (let i = 0; i < numOfvideos; i++) {
    if (Math.abs(i - ind) > delta) {
      videoEl = getVideoFromDiv(videoDivs[i]); 
      unloadVideo(videoEl);
          }
    else {
      videoEl = getVideoFromDiv(videoDivs[i]); 
      src = videoDivs[i].getAttribute('videourl');   
      if (i === ind)  {
        isInterceptedEl = true;
      }
      else {
        isInterceptedEl = false;
      }
      loadVideo(videoEl, src, isInterceptedEl);
    }
  }
}

export function unObserveAllVideoDivs() {
  if (lazyLoadingObserver && videoDivs) {
    videoDivs.forEach((videoDiv) => {
      lazyLoadingObserver.unobserve(videoDiv); 
    });
  }
}

export function unloadVideoFromDiv(videoDiv) {
  let video = getVideoFromDiv(videoDiv);

  unloadVideo(video);
}

export function getVideoFromDiv(videoDiv) {
  let video = videoDiv.querySelector("video"); // Directly selects the <video> element inside the div
  return video;
}

export function unloadAllVideos(that) {
  let video;

  if (PROCESS_VIDEOS || !isDesktop()) {
    lastObservedVideoIndexMap.set(that.className, lastObservedVideoIndex);
    lastObservedVideoIndex = UNSET;
    unObserveAllVideoDivs();
    if (videoDivs.length) {
      videoDivs.forEach((videoDiv) => {
        video = getVideoFromDiv(videoDiv);
        unloadVideo(video);
      });
    }
    videoDivs = [];
  }
}

function unloadVideo(videoEl) {
  let preloadAttr = videoEl.getAttribute('preload');
  let devicePreloadAttr = getDeviceVideoPreloadAttribute();

  if (preloadAttr === devicePreloadAttr) {
    videoEl.pause();
    videoEl.removeAttribute('src');
    videoEl.setAttribute('preload', 'none');
    videoEl.removeAttribute('autoplay');
    videoEl.setAttribute('playsinline', true);
    videoEl.load();
  }
}

async function loadVideo(videoEl, src, isInterceptedEl) {
  let preloadAttr = videoEl.getAttribute('preload');
  let devicePreloadAttr = getDeviceVideoPreloadAttribute();

  if (preloadAttr === 'none') {
    videoEl.setAttribute('src', src);
    videoEl.setAttribute('preload', devicePreloadAttr);
    videoEl.load();
  }
  else {
    if (!isInterceptedEl) {
      videoEl.pause();
    }
  }
}

export function resetLastObservedVideoIndex(that) {
  if (PROCESS_VIDEOS || !isDesktop()) {
    lastObservedVideoIndex = UNSET;
    lastObservedVideoIndexMap.set(that.className, lastObservedVideoIndex);
  }
}

function setLastObservedVideoIndex(observedVideoIndex) {
  lastObservedVideoIndex = observedVideoIndex;
}

export function getVideoConfig(post, that) {
   let config = {};
   let isPreload;
   let preloadAttribute;
   let attributes;

  if (PROCESS_VIDEOS || !isDesktop()) {
    if (that === null) {
      //shared post - no login user, or galley big image
      isPreload = true;
    }
    else {
      isPreload = videoPreloadCondtion(post.vdeoIndex, that);
    }
    preloadAttribute = getDeviceVideoPreloadAttribute();
    attributes = {
      preload : isPreload ? preloadAttribute : 'none',
      poster : post.thumbnail
    }
    config = {
      file: {
        attributes: attributes
      }
    };
  }
  else {
    config = {};
  }
  return config;
}

export function videoPreloadCondtion(index, that) {
  // Wee need this only for the rare use case when the 1st post has video
  // and it's very narrow - above the observer interval, so observer itself 
  // does not sets video preload attributes before fe start scrolling
  let cond = false;
  let lastObservedVideoIndexLocal = (lastObservedVideoIndex === UNSET) 
                                      ? lastObservedVideoIndexMap.get(that.className)
                                      : lastObservedVideoIndex;
  let loadVideoAtStartOfRendering = (lastObservedVideoIndexLocal === UNSET) &&
                                    (index < MAX_LOADED_VIDEOS);

  if (loadVideoAtStartOfRendering) {
    cond = true;
  }
  return cond;
}

export function isShowThumbNails() {
  return (SHOW_THUMBNAILS || !isDesktop());
}

export function getDeviceVideoPreloadAttribute() {
  let preload = isDesktop() ? 'auto' : 'metadata';

  return preload;
}